import React, { useState } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import ContinuousReportingCreateModal from './ContinuousReporting/ContinuousReportingCreateModal';
import ContinuousReportingTable from './ContinuousReporting/ContinuousReportingTable';
import { getStatementsByProjectId } from 'lib/api_ts/continuousReportingApi';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Loading } from '@components/atomic/atoms';

export type ContinuousReportingType = {
	id: number;
	continuosReportingNumber: string;
	note?: string;
	contextAndObjectives?: string;
	expectedOutcomes?: string;
	projectPolicyRelevance?: string;
	workPerformedAndResults?: string;
	projectId: number;
	sent: boolean;
	sentDate: string;
	approved: boolean;
	approvedDate: string;
	monthsApprovedDate: number;
	monthsSentDate: number;
};

interface ContinuousReportingProps {
	state: 'DRAFT' | 'VALIDATED';
	isProjectWp: boolean;
	isEnabledToView: boolean;
}

const ContinuousReporting: React.FC<ContinuousReportingProps> = ({ state, isProjectWp, isEnabledToView }) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];

	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

	const queryClient = useQueryClient();

	const fetchData = () => {
		queryClient.invalidateQueries({ queryKey: ['continuousStatements', projectId] });
	};

	const { data: statements, isLoading } = useQuery({
		queryKey: ['continuousStatements', projectId, state],
		queryFn: async () => {
			const statementsFromApi = await getStatementsByProjectId(projectId, state);
			return statementsFromApi.map((statement) => ({
				id: statement.id,
				continuosReportingNumber: statement.name,
				note: statement.note,
				projectId: statement.projectId,
				sent: statement.sent,
				sentDate: statement.sentDate,
				approved: statement.approved,
				approvedDate: statement.approvedDate,
				contextAndObjectives: statement.contextAndObjectives,
				expectedOutcomes: statement.expectedOutcomes,
				workPerformedAndResults: statement.workPerformedAndResults,
				projectPolicyRelevance: statement.projectPolicyRelevance,
				monthsApprovedDate: statement.monthsApprovedDate,
				monthsSentDate: statement.monthsSentDate,
			}));
		},
		enabled: projectId !== undefined,
		refetchOnMount: false,
	});

	return isLoading ? (
		<Loading fixedHeight="50vh" />
	) : (
		<>
			<ContinuousReportingTable
				rowData={statements || []}
				setIsCreateModalOpen={setIsCreateModalOpen}
				fetchData={fetchData}
				state={state}
				isProjectWp={isProjectWp}
				isEnabledToView={isEnabledToView}
			/>

			<ContinuousReportingCreateModal isModalOpen={isCreateModalOpen} setIsModalOpen={setIsCreateModalOpen} fetchData={fetchData} />
		</>
	);
};

export default ContinuousReporting;
